import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "Business",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "DelItemList",
  "GetItemById",
  "GetItemByBusinessId",
  "GetItemByBusinessCode",
  "FindByConditions",
  "FindAll",
  "GetPageContentByConditions",
  "GetQRCode",
  "RegSubMerInfoService",
  "QrySubMerchantInfoService",
  "UpdateSubMerchantStatusService",
  "VerifyMessageCodeAndRandomAmountService"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const BusinessApi = ZJApi.defineNewApi("BusinessApi", factory);

export default BusinessApi;
